<p-calendar
    panelStyleClass="table-calendar-mobile modal-calender"
    [todayButtonStyleClass]="'p-calender-today-button'"
    [clearButtonStyleClass]="'p-calender-clear-button'"
    *ngIf="!monthNavigator"
    [showIcon]="!to.disabled"
    [(ngModel)]="model[key]"
    [defaultDate]="defaultDate"
    [maxDate]="maxDate"
    [minDate]="minDate"
    [dateFormat]="format"
    [styleClass]="getStyleClass()"
    [selectOtherMonths]="true"
    [readonlyInput]="false"
    [yearRange]="yearRange"
    [disabled]="to.disabled"
    [showButtonBar]="true"
    [monthNavigator]="true"
    [yearNavigator]="true"
    [keepInvalid]="false"
    placeholder="yyyy-mm-dd"
    (onSelect)="selectionMade($event)"
    (onBlur)="markTouched()"
    (onClose)="markTouched()"
    (onClearClick)="cleared()">
</p-calendar>
<div *ngIf="monthNavigator" class="input-group date">
    <select
        [(ngModel)]="selectedMonth"
        class="form-control"
        (ngModelChange)="dateSelected(selectedYear, selectedMonth)"
    >
        <option *ngFor="let option of months" [ngValue]="option.value">
            {{ option.label }}
        </option>
    </select>
    <select
        [(ngModel)]="selectedYear"
        class="form-control"
        (ngModelChange)="dateSelected(selectedYear, selectedMonth)"
    >
        <option *ngFor="let option of years" [ngValue]="option.value">
            {{ option.label }}
        </option>
    </select>
</div>
